import React, { useState, useEffect, useContext } from 'react'

import Text from '../../../shared/ui/Text'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'


const styles = theme => ({
  root: {
  },
  day: {  
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),    
  },
  dayText: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 600
  },
  content: {
    backgroundColor: '#eee',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
    position: 'relative'
  },
  contentTitle: {
    fontSize: theme.typography.h6.fontSize,    
    fontWeight: 300    
  },
  contentSummary: {
    fontSize: theme.typography.body1.fontSize,
    color: '#888'
  },
  contentDetail: {
    position: 'relative',
    backgroundColor: '#eee',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  daySeparator: {
    height: theme.spacing(1)
  },
  contentSeparator: {
    height: theme.spacing(1),    
  },  
  codeText: {
    position: 'absolute',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    fontWeight: 'bold',
    color:'#286DCC',
    height:'100%',
    width:'100%'
  }
})

const ContentTypeView = ({ theme, classes, content, moduleIndex }) => {
  
  return (
    <Box style={{
        width: '100%',
        height: 0,
        paddingBottom: '100%',
        backgroundColor: 'lightgrey',
        opacity: 1,
        position:'relative'
      }}>
        {content.content_type === 'module' ?
        <>
          <Typography className={classes.codeText}>
            {moduleIndex < 10 ? '0'+(moduleIndex) : moduleIndex }
          </Typography>
        </>
        :
        <Typography className={classes.codeText}>{content.content_type.substr(0,1).toUpperCase()}</Typography>
        }
    </Box>
  )
}

const CourseContentsView = ({ theme, classes, course, user }) => {

  const days = Array.from(Array(course.training_days), (_, i) => i + 1)
  let moduleIndex = 1
  const [openExpand, setOpenExpand] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(null)

  const handleToggleContent = (value) => {
    setOpenExpand(!openExpand)
    setSelectedIndex(!openExpand ? value : null)
  }
  
  return (
    <Box display='flex' flexDirection='column' alignItems='stretched'
      className={classes.root}
      >
      { days.map(day => (
        <>
          <Box display='flex' className={classes.day}>
            <Typography className={classes.dayText}>
              Day {day}
            </Typography>
          </Box>
          { course.contents && course.contents.filter(c => c.day == day).map((content,index) => (
            <Box>
              <Box 
                display='flex' 
                className={classes.content} 
                onClick={() => handleToggleContent(day.day+"/"+index)}
                >
              <Box width='6em' flexShrink={0} ml={2}>
                <ContentTypeView theme={theme} classes={classes} 
                  content={content}
                  moduleIndex={moduleIndex}
                  />
              </Box>
              <Box flexGrow={1} ml={2}>
                <Typography className={classes.contentTitle} gutterBottom>
                  { content.title }
                </Typography>
                { content.summary &&
                  <Text text={content.summary} format='markdown' />
                }   
                <span style={{display:'none'}}>
                { content.content_type === 'module' && moduleIndex++} 
                </span>              
              </Box>
              {user.isLoggedIn &&
                <>
                  {selectedIndex === day.day+"/"+index ?
                  <ExpandLessIcon style={{position:'absolute', right: 16, top: 16}}/>
                  :
                  <ExpandMoreIcon style={{position:'absolute', right: 16, top: 16}}/>
                  }
                  
                </>
              }
              </Box>
              {user.isLoggedIn && selectedIndex === day.day+"/"+index &&
              <Box className={classes.contentDetail}>
                <Text text={content.detail} format='markdown' />
              </Box>
              }
            </Box>
            )).reduce((p, n) => p ?
              [...p, <Box className={classes.contentSeparator} /> , n] : [n], null
            )
          }
        </>  
        )).reduce((p, n) => p ?
          [...p, <Box className={classes.daySeparator} /> , n] : [n], null
        )
      }
    </Box>
  )  
}

export default withStyles(styles, { withTheme: true })(
  CourseContentsView
)
